module.exports = __webpack_public_path__ + "img/step1-b.d34322d2.png";